
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ManageBookingOrderHeader',

  props: {
    contentPreloaderEnabled: {
      type: Boolean,
      required: true,
    },
  },
});
